/**
 *
 * Handle toggle share this button on signle event page
 */
jQuery(document).ready(function($) {
	$('.toggle-share').hover(function () {
	   $('.share-content').stop().slideToggle('slow');
	});
});
